export { default } from "./Data";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-processing/Data/index.js